import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux'
import Container from '@material-ui/core/Container';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import {StripeProvider} from 'react-stripe-elements';
import Modal from '@material-ui/core/Modal';
import {Elements} from 'react-stripe-elements';
import CheckoutForm from './component/CheckoutForm';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { css } from '@emotion/core';
import { RingLoader } from 'react-spinners';
import {makeStyles} from "@material-ui/core";
import {H4} from "./component/Typeset"
import styled from 'styled-components'
import {Route, Routes, useLocation, useNavigate} from 'react-router-dom';
import BuyTicket from "./pages/BuyTicket";
import Main from './pages/Main';
import AuthPage from './pages/AuthPage';
import Resale from "./pages/Resale";


const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

const containerStyle = makeStyles({
  root: {
    zIndex: 10,
    position: 'relative'
  },
  header: {
    backgroundColor: 'transparent',
    boxShadow: 'none'
  },
  headerButton: {
    color: 'white',
    '& .MuiButton-label': {
      borderBottom: '2px solid transparent'
    },
  },
  headerButtonActive: {
    color: 'white',
    '& .MuiButton-label': {
      borderBottom: '2px solid white'
    },
  },
});

const AppContainer = styled.div`
  &:before {
    content: "";
    position: absolute;
    top: 0; left: 0;
    width: 100%;
    height: 100%;
    background-color: black;
    opacity: 0.3;
    z-index: 0;
  }
`;


const App = props => {
  const navigate = useNavigate();
  const location = useLocation();
  const classes = containerStyle();

  useEffect(() => {
    (async () => await props.startUp())();
  },[]);

  return (
    <AppContainer style={{
      backgroundImage: props.isLoggedIn ?
        'url(/static/triniq_ticket/img/triniq-loading-bg.jpg)' :
        'url(/static/triniq_ticket/img/triniq_home_bg.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundBlendMode: 'darken',
      height: '100vh'
    }}>
      <Container className={classes.root} maxWidth="md">
        <div style={{textAlign: "center", marginTop: '0'}}>
          <a href={'/'}>
            <img alt={'Triniq'}
                 width={100}
                 src={'https://dtxpraavo1rvp.cloudfront.net/images/triniq-logo-light.8dd9b40c.png'}
            />
          </a>
        </div>
        <AppBar className={classes.header} position="static">
          <Toolbar disableGutters style={{margin: '0 -8px'}}>
            <Button
              style={{display: props.isLoggedIn ? 'inline-block' : 'none'}}
              className={location.pathname === '/profile' ? classes.headerButtonActive : classes.headerButton }
              onClick={() => navigate('/profile')}>
              My Tickets
            </Button>

            <Button
              style={{display: props.isLoggedIn ? 'inline-block' : 'none'}}
              className={location.pathname === '/resale/' ? classes.headerButtonActive : classes.headerButton}
              onClick={() => navigate('/resale/')}>
              Resale Market
            </Button>
            <div style={{flexGrow: 1}}/>

            <Button
              style={{display: props.isLoggedIn ? 'inline-block' : 'none'}}
              className={classes.headerButton} onClick={() => props.logout()}>
              Logout
            </Button>
          </Toolbar>
        </AppBar>
        <div>
          {props.isLoggedIn ?
            <div>
              <H4 style={{marginTop: 0}}>
                Welcome, {props.email}
              </H4>
              <Routes>
                <Route path="/resale/:ticketTransferUri" element={<BuyTicket />} />
                <Route path="/resale/" element={<Resale />} />
                <Route path="/profile" index element={<Main />} />
                <Route path="/" index element={<Main />} />
              </Routes>
            </div> :
            <AuthPage />
          }
        </div>

        {props.stripePublishableKey &&
        <Modal disableEnforceFocus open={props.showNameChangePaymentDialog}>
          <div>
            <StripeProvider apiKey={props.stripePublishableKey}>
              <Elements>
                <CheckoutForm
                  onCancel={props.cancelNameChange}
                  onSubmit={props.setLoadingModalVisible}
                  onFailure={props.setLoadingModalHide}
                  onSuccess={props.updateName}
                  fromName={props.fromName}
                  toName={props.toName}
                  priceStr={props.nameChangePriceStr}
                  clientIntentClientSecret={props.clientIntentClientSecret}
                  nameChangeTicketDescription={props.nameChangeTicketDescription}
                />
              </Elements>
            </StripeProvider>
          </div>
        </Modal>
        }

        <Modal disableEnforceFocus open={props.showLoadingModal}>
          <div style={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            outline: 'none'
          }}>
            <RingLoader
              css={override}
              sizeUnit={"px"}
              size={120}
              color={'#019CD0'}
              loading
            />
          </div>
        </Modal>

        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={props.showChangeSuccessMsg}
          autoHideDuration={5000}
          onClose={props.closeNameChangeSuccessMsg}
        >
          <SnackbarContent
            style={{
              backgroundColor: '#42474c'
            }}
            message={
              <span id="client-snackbar" style={{
                display: 'flex',
                alignItems: 'center',
              }}>
                <CheckCircleIcon style={{fontSize: 20, marginRight: 10}}/>
                Name change successful!
              </span>
            }
            action={
              <IconButton color="inherit" onClick={props.closeNameChangeSuccessMsg}>
                <CloseIcon style={{fontSize: 20}}/>
              </IconButton>
            }
          />
        </Snackbar>
      </Container>
    </AppContainer>
  );
}

const mapState = state => {
  return {
    email: state.auth.email,
    isLoggedIn: state.auth.isLoggedIn,
    showNameChangePaymentDialog: state.ticket.showNameChangePaymentDialog,
    stripePublishableKey: state.ticket.stripePublishableKey,
    clientIntentClientSecret: state.ticket.clientIntentClientSecret,
    nameChangePriceStr: state.ticket.nameChangePriceStr,
    fromName: state.ticket.fromName,
    toName: state.ticket.toName,
    showChangeSuccessMsg: state.ticket.showChangeSuccessMsg,
    showLoadingModal: state.ticket.showLoadingModal,
    nameChangeTicketDescription: state.ticket.nameChangeTicketDescription
  }
}

const mapDispatch = dispatch => ({
  updateName: dispatch.ticket.updateName,
  logout: dispatch.auth.logout,
  startUp: dispatch.auth.startUp,
  cancelNameChange: dispatch.ticket.cancelNameChange,
  closeNameChangeSuccessMsg: dispatch.ticket.closeNameChangeSuccessMsg,
  setLoadingModalVisible: dispatch.ticket.setLoadingModalVisible,
  setLoadingModalHide: dispatch.ticket.setLoadingModalHide,
})

export default connect(mapState, mapDispatch)(App);
